import { useMutation } from '@tanstack/vue-query';

import { actualizeProducts } from '../api';
import type { ActualizePayload } from '../types';

// MI - Medical Insurance

export const useMiProductsActualize = (offerId: string) => {
  return useMutation({
    mutationKey: ['actualizeMedicalInsuranceProducts', offerId],
    mutationFn(products: ActualizePayload[]) {
      return actualizeProducts(products, offerId);
    },
  });
};
